export const endpoints = {
  LOGIN: `cnaps-student/v1/student/login`,
  PROFILE: ``,
  LOGOUT: ``,
};

export const loginTypes = {
  LOGIN_REQUEST: "student/login/LOGIN_REQUEST",
  LOGIN_SUCCESS: "student/login/LOGIN_SUCCESS",
  LOGIN_ERROR: "student/login/LOGIN_ERROR",
  RESET_ERROR: "student/login/RESET_ERROR",

  LOGOUT_REQUEST: "student/login/LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "student/login/LOGOUT_SUCCESS",
  LOGOUT_ERROR: "student/login/LOGOUT_ERROR",

  PROFILE_REQUEST: "student/login/PROFILE_REQUEST",
  PROFILE_SUCCESS: "student/login/PROFILE_SUCCESS",
  PROFILE_ERROR: "student/login/PROFILE_ERROR",
};
